import { supportedLanguages } from './types.no-deps'

export enum ESystem {
    APP = 'app',
    APPCORE = 'appcore',
    SHARED = 'shared',
    SERVER = 'server',
    AUTH = 'auth',
    PORTAL = 'portal',
    TEST = 'test',
}

type Translations = { [key in ESystem]: any }

const translations: Partial<Translations> = {
    app: null,
    appcore: null,
    shared: null,
    server: null,
    auth: null,
    portal: null,
}

// app
import enGB from '../../app/i18n/split-auto/en-GB/app.json'
import deDE from '../../app/i18n/split-auto/de-DE/app.json'
import esES from '../../app/i18n/split-auto/es-ES/app.json'
import elGR from '../../app/i18n/split-auto/el-GR/app.json'
import frFR from '../../app/i18n/split-auto/fr-FR/app.json'
import itIT from '../../app/i18n/split-auto/it-IT/app.json'
import ptBR from '../../app/i18n/split-auto/pt-BR/app.json'
import ptPT from '../../app/i18n/split-auto/pt-PT/app.json'
import ruRU from '../../app/i18n/split-auto/ru-RU/app.json'
import srSP from '../../app/i18n/split-auto/sr-SP/app.json'
import zhCN from '../../app/i18n/split-auto/zh-CN/app.json'
import ukUA from '../../app/i18n/split-auto/uk-UA/app.json'
import lvLV from '../../app/i18n/split-auto/lv-LV/app.json'
import ltLT from '../../app/i18n/split-auto/lt-LT/app.json'
import etEE from '../../app/i18n/split-auto/et-EE/app.json'
import bgBG from '../../app/i18n/split-auto/bg-BG/app.json'
import kmKH from '../../app/i18n/split-auto/km-KH/app.json'
import jaJP from '../../app/i18n/split-auto/ja-JP/app.json'
import viVN from '../../app/i18n/split-auto/vi-VN/app.json'
import plPL from '../../app/i18n/split-auto/pl-PL/app.json'
import nlNL from '../../app/i18n/split-auto/nl-NL/app.json'
import huHU from '../../app/i18n/split-auto/hu-HU/app.json'
import csCZ from '../../app/i18n/split-auto/cs-CZ/app.json'
import roRO from '../../app/i18n/split-auto/ro-RO/app.json'
import skSK from '../../app/i18n/split-auto/sk-SK/app.json'
import hrHR from '../../app/i18n/split-auto/hr-HR/app.json'
import msMY from '../../app/i18n/split-auto/ms-MY/app.json'
import frCA from '../../app/i18n/split-auto/fr-CA/app.json'
import noNO from '../../app/i18n/split-auto/no-NO/app.json'
import trTR from '../../app/i18n/split-auto/tr-TR/app.json'
import nlBE from '../../app/i18n/split-auto/nl-BE/app.json'
import kkKZ from '../../app/i18n/split-auto/kk-KZ/app.json'
import idID from '../../app/i18n/split-auto/id-ID/app.json'
import filPH from '../../app/i18n/split-auto/fil-PH/app.json'
import koKR from '../../app/i18n/split-auto/ko-KR/app.json'
import srLatnRS from '../../app/i18n/split-auto/sr-Latn-RS/app.json'

// app-core
import enGBCore from '../../app-core/i18n/split-auto/en-GB/appcore.json'
import deDECore from '../../app-core/i18n/split-auto/de-DE/appcore.json'
import esESCore from '../../app-core/i18n/split-auto/es-ES/appcore.json'
import elGRCore from '../../app-core/i18n/split-auto/el-GR/appcore.json'
import frFRCore from '../../app-core/i18n/split-auto/fr-FR/appcore.json'
import itITCore from '../../app-core/i18n/split-auto/it-IT/appcore.json'
import ptBRCore from '../../app-core/i18n/split-auto/pt-BR/appcore.json'
import ptPTCore from '../../app-core/i18n/split-auto/pt-PT/appcore.json'
import ruRUCore from '../../app-core/i18n/split-auto/ru-RU/appcore.json'
import srSPCore from '../../app-core/i18n/split-auto/sr-SP/appcore.json'
import zhCNCore from '../../app-core/i18n/split-auto/zh-CN/appcore.json'
import ukUACore from '../../app-core/i18n/split-auto/uk-UA/appcore.json'
import lvLVCore from '../../app-core/i18n/split-auto/lv-LV/appcore.json'
import ltLTCore from '../../app-core/i18n/split-auto/lt-LT/appcore.json'
import etEECore from '../../app-core/i18n/split-auto/et-EE/appcore.json'
import bgBGCore from '../../app-core/i18n/split-auto/bg-BG/appcore.json'
import kmKHCore from '../../app-core/i18n/split-auto/km-KH/appcore.json'
import jaJPCore from '../../app-core/i18n/split-auto/ja-JP/appcore.json'
import viVNCore from '../../app-core/i18n/split-auto/vi-VN/appcore.json'
import plPLCore from '../../app-core/i18n/split-auto/pl-PL/appcore.json'
import nlNLCore from '../../app-core/i18n/split-auto/nl-NL/appcore.json'
import huHUCore from '../../app-core/i18n/split-auto/hu-HU/appcore.json'
import csCZCore from '../../app-core/i18n/split-auto/cs-CZ/appcore.json'
import roROCore from '../../app-core/i18n/split-auto/ro-RO/appcore.json'
import skSKCore from '../../app-core/i18n/split-auto/sk-SK/appcore.json'
import hrHRCore from '../../app-core/i18n/split-auto/hr-HR/appcore.json'
import msMYCore from '../../app-core/i18n/split-auto/ms-MY/appcore.json'
import frCACore from '../../app-core/i18n/split-auto/fr-CA/appcore.json'
import noNOCore from '../../app-core/i18n/split-auto/no-NO/appcore.json'
import trTRCore from '../../app-core/i18n/split-auto/tr-TR/appcore.json'
import nlBECore from '../../app-core/i18n/split-auto/nl-BE/appcore.json'
import kkKZCore from '../../app-core/i18n/split-auto/kk-KZ/appcore.json'
import idIDCore from '../../app-core/i18n/split-auto/id-ID/appcore.json'
import filPHCore from '../../app-core/i18n/split-auto/fil-PH/appcore.json'
import koKRCore from '../../app-core/i18n/split-auto/ko-KR/appcore.json'
import srLatnRSCore from '../../app-core/i18n/split-auto/sr-Latn-RS/appcore.json'

// shared
import enGBShared from '../../shared/i18n/split-auto/en-GB/shared.json'
import deDEShared from '../../shared/i18n/split-auto/de-DE/shared.json'
import esESShared from '../../shared/i18n/split-auto/es-ES/shared.json'
import elGRShared from '../../shared/i18n/split-auto/el-GR/shared.json'
import frFRShared from '../../shared/i18n/split-auto/fr-FR/shared.json'
import itITShared from '../../shared/i18n/split-auto/it-IT/shared.json'
import ptBRShared from '../../shared/i18n/split-auto/pt-BR/shared.json'
import ptPTShared from '../../shared/i18n/split-auto/pt-PT/shared.json'
import ruRUShared from '../../shared/i18n/split-auto/ru-RU/shared.json'
import srSPShared from '../../shared/i18n/split-auto/sr-SP/shared.json'
import zhCNShared from '../../shared/i18n/split-auto/zh-CN/shared.json'
import ukUAShared from '../../shared/i18n/split-auto/uk-UA/shared.json'
import lvLVShared from '../../shared/i18n/split-auto/lv-LV/shared.json'
import ltLTShared from '../../shared/i18n/split-auto/lt-LT/shared.json'
import etEEShared from '../../shared/i18n/split-auto/et-EE/shared.json'
import bgBGShared from '../../shared/i18n/split-auto/bg-BG/shared.json'
import kmKHShared from '../../shared/i18n/split-auto/km-KH/shared.json'
import jaJPShared from '../../shared/i18n/split-auto/ja-JP/shared.json'
import viVNShared from '../../shared/i18n/split-auto/vi-VN/shared.json'
import plPLShared from '../../shared/i18n/split-auto/pl-PL/shared.json'
import nlNLShared from '../../shared/i18n/split-auto/nl-NL/shared.json'
import huHUShared from '../../shared/i18n/split-auto/hu-HU/shared.json'
import csCZShared from '../../shared/i18n/split-auto/cs-CZ/shared.json'
import roROShared from '../../shared/i18n/split-auto/ro-RO/shared.json'
import skSKShared from '../../shared/i18n/split-auto/sk-SK/shared.json'
import hrHRShared from '../../shared/i18n/split-auto/hr-HR/shared.json'
import msMYShared from '../../shared/i18n/split-auto/ms-MY/shared.json'
import frCAShared from '../../shared/i18n/split-auto/fr-CA/shared.json'
import noNOShared from '../../shared/i18n/split-auto/no-NO/shared.json'
import trTRShared from '../../shared/i18n/split-auto/tr-TR/shared.json'
import nlBEShared from '../../shared/i18n/split-auto/nl-BE/shared.json'
import kkKZShared from '../../shared/i18n/split-auto/kk-KZ/shared.json'
import idIDShared from '../../shared/i18n/split-auto/id-ID/shared.json'
import filPHShared from '../../shared/i18n/split-auto/fil-PH/shared.json'
import koKRShared from '../../shared/i18n/split-auto/ko-KR/shared.json'
import srLatnRSShared from '../../shared/i18n/split-auto/sr-Latn-RS/shared.json'

// server
import enGBServer from '../../i18n/split-auto/en-GB/server.json'
import deDEServer from '../../i18n/split-auto/de-DE/server.json'
import esESServer from '../../i18n/split-auto/es-ES/server.json'
import elGRServer from '../../i18n/split-auto/el-GR/server.json'
import frFRServer from '../../i18n/split-auto/fr-FR/server.json'
import itITServer from '../../i18n/split-auto/it-IT/server.json'
import ptBRServer from '../../i18n/split-auto/pt-BR/server.json'
import ptPTServer from '../../i18n/split-auto/pt-PT/server.json'
import ruRUServer from '../../i18n/split-auto/ru-RU/server.json'
import srSPServer from '../../i18n/split-auto/sr-SP/server.json'
import zhCNServer from '../../i18n/split-auto/zh-CN/server.json'
import ukUAServer from '../../i18n/split-auto/uk-UA/server.json'
import lvLVServer from '../../i18n/split-auto/lv-LV/server.json'
import ltLTServer from '../../i18n/split-auto/lt-LT/server.json'
import etEEServer from '../../i18n/split-auto/et-EE/server.json'
import bgBGServer from '../../i18n/split-auto/bg-BG/server.json'
import kmKHServer from '../../i18n/split-auto/km-KH/server.json'
import jaJPServer from '../../i18n/split-auto/ja-JP/server.json'
import viVNServer from '../../i18n/split-auto/vi-VN/server.json'
import plPLServer from '../../i18n/split-auto/pl-PL/server.json'
import nlNLServer from '../../i18n/split-auto/nl-NL/server.json'
import huHUServer from '../../i18n/split-auto/hu-HU/server.json'
import csCZServer from '../../i18n/split-auto/cs-CZ/server.json'
import roROServer from '../../i18n/split-auto/ro-RO/server.json'
import skSKServer from '../../i18n/split-auto/sk-SK/server.json'
import hrHRServer from '../../i18n/split-auto/hr-HR/server.json'
import msMYServer from '../../i18n/split-auto/ms-MY/server.json'
import frCAServer from '../../i18n/split-auto/fr-CA/server.json'
import noNOServer from '../../i18n/split-auto/no-NO/server.json'
import trTRServer from '../../i18n/split-auto/tr-TR/server.json'
import nlBEServer from '../../i18n/split-auto/nl-BE/server.json'
import kkKZServer from '../../i18n/split-auto/kk-KZ/server.json'
import idIDServer from '../../i18n/split-auto/id-ID/server.json'
import filPHServer from '../../i18n/split-auto/fil-PH/server.json'
import koKRServer from '../../i18n/split-auto/ko-KR/server.json'
import srLatnRSServer from '../../i18n/split-auto/sr-Latn-RS/server.json'

// auth
import enGBAuth from '../../auth/i18n/split-auto/en-GB/auth.json'
import deDEAuth from '../../auth/i18n/split-auto/de-DE/auth.json'
import esESAuth from '../../auth/i18n/split-auto/es-ES/auth.json'
import elGRAuth from '../../auth/i18n/split-auto/el-GR/auth.json'
import frFRAuth from '../../auth/i18n/split-auto/fr-FR/auth.json'
import itITAuth from '../../auth/i18n/split-auto/it-IT/auth.json'
import ptBRAuth from '../../auth/i18n/split-auto/pt-BR/auth.json'
import ptPTAuth from '../../auth/i18n/split-auto/pt-PT/auth.json'
import ruRUAuth from '../../auth/i18n/split-auto/ru-RU/auth.json'
import srSPAuth from '../../auth/i18n/split-auto/sr-SP/auth.json'
import zhCNAuth from '../../auth/i18n/split-auto/zh-CN/auth.json'
import ukUAAuth from '../../auth/i18n/split-auto/uk-UA/auth.json'
import lvLVAuth from '../../auth/i18n/split-auto/lv-LV/auth.json'
import ltLTAuth from '../../auth/i18n/split-auto/lt-LT/auth.json'
import etEEAuth from '../../auth/i18n/split-auto/et-EE/auth.json'
import bgBGAuth from '../../auth/i18n/split-auto/bg-BG/auth.json'
import kmKHAuth from '../../auth/i18n/split-auto/km-KH/auth.json'
import jaJPAuth from '../../auth/i18n/split-auto/ja-JP/auth.json'
import viVNAuth from '../../auth/i18n/split-auto/vi-VN/auth.json'
import plPLAuth from '../../auth/i18n/split-auto/pl-PL/auth.json'
import nlNLAuth from '../../auth/i18n/split-auto/nl-NL/auth.json'
import huHUAuth from '../../auth/i18n/split-auto/hu-HU/auth.json'
import csCZAuth from '../../auth/i18n/split-auto/cs-CZ/auth.json'
import roROAuth from '../../auth/i18n/split-auto/ro-RO/auth.json'
import skSKAuth from '../../auth/i18n/split-auto/sk-SK/auth.json'
import hrHRAuth from '../../auth/i18n/split-auto/hr-HR/auth.json'
import msMYAuth from '../../auth/i18n/split-auto/ms-MY/auth.json'
import frCAAuth from '../../auth/i18n/split-auto/fr-CA/auth.json'
import noNOAuth from '../../auth/i18n/split-auto/no-NO/auth.json'
import trTRAuth from '../../auth/i18n/split-auto/tr-TR/auth.json'
import nlBEAuth from '../../auth/i18n/split-auto/nl-BE/auth.json'
import kkKZAuth from '../../auth/i18n/split-auto/kk-KZ/auth.json'
import idIDAuth from '../../auth/i18n/split-auto/id-ID/auth.json'
import filPHAuth from '../../auth/i18n/split-auto/fil-PH/auth.json'
import koKRAuth from '../../auth/i18n/split-auto/ko-KR/auth.json'
import srLatnRSAuth from '../../auth/i18n/split-auto/sr-Latn-RS/auth.json'

// portal
import enGBPortal from '../../portal/apps/i18n/split-auto/en-GB/portal.json'
import deDEPortal from '../../portal/apps/i18n/split-auto/de-DE/portal.json'
import esESPortal from '../../portal/apps/i18n/split-auto/es-ES/portal.json'
import elGRPortal from '../../portal/apps/i18n/split-auto/el-GR/portal.json'
import frFRPortal from '../../portal/apps/i18n/split-auto/fr-FR/portal.json'
import itITPortal from '../../portal/apps/i18n/split-auto/it-IT/portal.json'
import ptBRPortal from '../../portal/apps/i18n/split-auto/pt-BR/portal.json'
import ptPTPortal from '../../portal/apps/i18n/split-auto/pt-PT/portal.json'
import ruRUPortal from '../../portal/apps/i18n/split-auto/ru-RU/portal.json'
import srSPPortal from '../../portal/apps/i18n/split-auto/sr-SP/portal.json'
import zhCNPortal from '../../portal/apps/i18n/split-auto/zh-CN/portal.json'
import ukUAPortal from '../../portal/apps/i18n/split-auto/uk-UA/portal.json'
import lvLVPortal from '../../portal/apps/i18n/split-auto/lv-LV/portal.json'
import ltLTPortal from '../../portal/apps/i18n/split-auto/lt-LT/portal.json'
import etEEPortal from '../../portal/apps/i18n/split-auto/et-EE/portal.json'
import bgBGPortal from '../../portal/apps/i18n/split-auto/bg-BG/portal.json'
import kmKHPortal from '../../portal/apps/i18n/split-auto/km-KH/portal.json'
import jaJPPortal from '../../portal/apps/i18n/split-auto/ja-JP/portal.json'
import viVNPortal from '../../portal/apps/i18n/split-auto/vi-VN/portal.json'
import plPLPortal from '../../portal/apps/i18n/split-auto/pl-PL/portal.json'
import nlNLPortal from '../../portal/apps/i18n/split-auto/nl-NL/portal.json'
import huHUPortal from '../../portal/apps/i18n/split-auto/hu-HU/portal.json'
import csCZPortal from '../../portal/apps/i18n/split-auto/cs-CZ/portal.json'
import roROPortal from '../../portal/apps/i18n/split-auto/ro-RO/portal.json'
import skSKPortal from '../../portal/apps/i18n/split-auto/sk-SK/portal.json'
import hrHRPortal from '../../portal/apps/i18n/split-auto/hr-HR/portal.json'
import msMYPortal from '../../portal/apps/i18n/split-auto/ms-MY/portal.json'
import frCAPortal from '../../portal/apps/i18n/split-auto/fr-CA/portal.json'
import noNOPortal from '../../portal/apps/i18n/split-auto/no-NO/portal.json'
import trTRPortal from '../../portal/apps/i18n/split-auto/tr-TR/portal.json'
import nlBEPortal from '../../portal/apps/i18n/split-auto/nl-BE/portal.json'
import kkKZPortal from '../../portal/apps/i18n/split-auto/kk-KZ/portal.json'
import idIDPortal from '../../portal/apps/i18n/split-auto/id-ID/portal.json'
import filPHPortal from '../../portal/apps/i18n/split-auto/fil-PH/portal.json'
import koKRPortal from '../../portal/apps/i18n/split-auto/ko-KR/portal.json'
import srLatnRSPortal from '../../portal/apps/i18n/split-auto/sr-Latn-RS/portal.json'

export const resources: { [langCode: string]: { [namespace: string]: any } } = {
    'en-GB': {
        app: enGB,
        appcore: enGBCore,
        shared: enGBShared,
        server: enGBServer,
        auth: enGBAuth,
        portal: enGBPortal,
    },
    'de-DE': {
        app: deDE,
        appcore: deDECore,
        shared: deDEShared,
        server: deDEServer,
        auth: deDEAuth,
        portal: deDEPortal,
    },
    'es-ES': {
        app: esES,
        appcore: esESCore,
        shared: esESShared,
        server: esESServer,
        auth: esESAuth,
        portal: esESPortal,
    },
    'el-GR': {
        app: elGR,
        appcore: elGRCore,
        shared: elGRShared,
        server: elGRServer,
        auth: elGRAuth,
        portal: elGRPortal,
    },
    'fr-FR': {
        app: frFR,
        appcore: frFRCore,
        shared: frFRShared,
        server: frFRServer,
        auth: frFRAuth,
        portal: frFRPortal,
    },
    'it-IT': {
        app: itIT,
        appcore: itITCore,
        shared: itITShared,
        server: itITServer,
        auth: itITAuth,
        portal: itITPortal,
    },
    'pt-BR': {
        app: ptBR,
        appcore: ptBRCore,
        shared: ptBRShared,
        server: ptBRServer,
        auth: ptBRAuth,
        portal: ptBRPortal,
    },
    'pt-PT': {
        app: ptPT,
        appcore: ptPTCore,
        shared: ptPTShared,
        server: ptPTServer,
        auth: ptPTAuth,
        portal: ptPTPortal,
    },
    'ru-RU': {
        app: ruRU,
        appcore: ruRUCore,
        shared: ruRUShared,
        server: ruRUServer,
        auth: ruRUAuth,
        portal: ruRUPortal,
    },
    'sr-SP': {
        app: srSP,
        appcore: srSPCore,
        shared: srSPShared,
        server: srSPServer,
        auth: srSPAuth,
        portal: srSPPortal,
    },
    'zh-CN': {
        app: zhCN,
        appcore: zhCNCore,
        shared: zhCNShared,
        server: zhCNServer,
        auth: zhCNAuth,
        portal: zhCNPortal,
    },
    'uk-UA': {
        app: ukUA,
        appcore: ukUACore,
        shared: ukUAShared,
        server: ukUAServer,
        auth: ukUAAuth,
        portal: ukUAPortal,
    },
    'lv-LV': {
        app: lvLV,
        appcore: lvLVCore,
        shared: lvLVShared,
        server: lvLVServer,
        auth: lvLVAuth,
        portal: lvLVPortal,
    },
    'lt-LT': {
        app: ltLT,
        appcore: ltLTCore,
        shared: ltLTShared,
        server: ltLTServer,
        auth: ltLTAuth,
        portal: ltLTPortal,
    },
    'et-EE': {
        app: etEE,
        appcore: etEECore,
        shared: etEEShared,
        server: etEEServer,
        auth: etEEAuth,
        portal: etEEPortal,
    },
    'bg-BG': {
        app: bgBG,
        appcore: bgBGCore,
        shared: bgBGShared,
        server: bgBGServer,
        auth: bgBGAuth,
        portal: bgBGPortal,
    },
    'km-KH': {
        app: kmKH,
        appcore: kmKHCore,
        shared: kmKHShared,
        server: kmKHServer,
        auth: kmKHAuth,
        portal: kmKHPortal,
    },
    'ja-JP': {
        app: jaJP,
        appcore: jaJPCore,
        shared: jaJPShared,
        server: jaJPServer,
        auth: jaJPAuth,
        portal: jaJPPortal,
    },
    'vi-VN': {
        app: viVN,
        appcore: viVNCore,
        shared: viVNShared,
        server: viVNServer,
        auth: viVNAuth,
        portal: viVNPortal,
    },
    'nl-NL': {
        app: nlNL,
        appcore: nlNLCore,
        shared: nlNLShared,
        server: nlNLServer,
        auth: nlNLAuth,
        portal: nlNLPortal,
    },
    'pl-PL': {
        app: plPL,
        appcore: plPLCore,
        shared: plPLShared,
        server: plPLServer,
        auth: plPLAuth,
        portal: plPLPortal,
    },
    'cs-CZ': {
        app: csCZ,
        appcore: csCZCore,
        shared: csCZShared,
        server: csCZServer,
        auth: csCZAuth,
        portal: csCZPortal,
    },
    'sk-SK': {
        app: skSK,
        appcore: skSKCore,
        shared: skSKShared,
        server: skSKServer,
        auth: skSKAuth,
        portal: skSKPortal,
    },
    'hu-HU': {
        app: huHU,
        appcore: huHUCore,
        shared: huHUShared,
        server: huHUServer,
        auth: huHUAuth,
        portal: huHUPortal,
    },
    'ro-RO': {
        app: roRO,
        appcore: roROCore,
        shared: roROShared,
        server: roROServer,
        auth: roROAuth,
        portal: roROPortal,
    },
    'hr-HR': {
        app: hrHR,
        appcore: hrHRCore,
        shared: hrHRShared,
        server: hrHRServer,
        auth: hrHRAuth,
        portal: hrHRPortal,
    },
    'ms-MY': {
        app: msMY,
        appcore: msMYCore,
        shared: msMYShared,
        server: msMYServer,
        auth: msMYAuth,
        portal: msMYPortal,
    },
    'fr-CA': {
        app: frCA,
        appcore: frCACore,
        shared: frCAShared,
        server: frCAServer,
        auth: frCAAuth,
        portal: frCAPortal,
    },
    'no-NO': {
        app: noNO,
        appcore: noNOCore,
        shared: noNOShared,
        server: noNOServer,
        auth: noNOAuth,
        portal: noNOPortal,
    },
    'tr-TR': {
        app: trTR,
        appcore: trTRCore,
        shared: trTRShared,
        server: trTRServer,
        auth: trTRAuth,
        portal: trTRPortal,
    },
    'nl-BE': {
        app: nlBE,
        appcore: nlBECore,
        shared: nlBEShared,
        server: nlBEServer,
        auth: nlBEAuth,
        portal: nlBEPortal,
    },
    'kk-KZ': {
        app: kkKZ,
        appcore: kkKZCore,
        shared: kkKZShared,
        server: kkKZServer,
        auth: kkKZAuth,
        portal: kkKZPortal,
    },
    'id-ID': {
        app: idID,
        appcore: idIDCore,
        shared: idIDShared,
        server: idIDServer,
        auth: idIDAuth,
        portal: idIDPortal,
    },
    'fil-PH': {
        app: filPH,
        appcore: filPHCore,
        shared: filPHShared,
        server: filPHServer,
        auth: filPHAuth,
        portal: filPHPortal,
    },
    'ko-KR': {
        app: koKR,
        appcore: koKRCore,
        shared: koKRShared,
        server: koKRServer,
        auth: koKRAuth,
        portal: koKRPortal,
    },
    'sr-Latn-RS': {
        app: srLatnRS,
        appcore: srLatnRSCore,
        shared: srLatnRSShared,
        server: srLatnRSServer,
        auth: srLatnRSAuth,
        portal: srLatnRSPortal,
    },
}

export async function loadTranslationsForSystem(system: ESystem) {
    if (translations[system]) {
        return translations[system]
    }

    const t: { [key: string]: any } = {}
    for (const lang of supportedLanguages) {
        t[lang] = resources[lang][system]
    }

    return t
}

export async function loadTranslations(systems: ESystem[]) {
    const systemTranslations: { [key: string]: any } = {}

    // load translation files
    for (const system of systems) {
        systemTranslations[system] = await loadTranslationsForSystem(system)
    }

    const t: { [key: string]: any } = {}
    for (const lang of supportedLanguages) {
        for (const system of systems) {
            if (!t[lang]) {
                t[lang] = {}
            }
            t[lang][system] = systemTranslations[system][lang]
        }
    }

    return t
}

export function loadSystemTranslations(system: ESystem) {
    switch (system) {
        case ESystem.APP:
            return loadTranslations([ESystem.APP, ESystem.APPCORE, ESystem.SHARED])
        case ESystem.APPCORE:
            return loadTranslations([ESystem.APPCORE, ESystem.SHARED])
        case ESystem.SHARED:
            return loadTranslations([ESystem.SHARED])
        case ESystem.PORTAL:
            return loadTranslations([ESystem.APPCORE, ESystem.SHARED, ESystem.PORTAL])
        case ESystem.AUTH:
            return loadTranslations([ESystem.AUTH])
        case ESystem.SERVER:
            return loadTranslations([ESystem.SERVER])
        case ESystem.TEST:
            return loadTranslations(Object.values(ESystem).filter((s) => s !== 'test'))
    }
}
